module.exports = __webpack_public_path__ + "static/media/22-4.557f5c67.mp3";